import type { MailboxInfo } from "owa-client-types";
import store, { defaultFocusedInboxOptionState } from "../store/store";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import type FocusedInboxOptionState from "../store/schema/FocusedInboxOptionState";

// Warning: This function mutates the store map, it should only be called
// inside mutators, that's why it is on the actions folder
export function getStateAndCreateIfUndefined(mailboxInfo: MailboxInfo): FocusedInboxOptionState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    if (!store().entries.get(accountKey)) {
        store().entries.set(accountKey, defaultFocusedInboxOptionState());
    }
    
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
     * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
     *	> Forbidden non-null assertion. */
    return store().entries.get(accountKey)!;
}
